import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import FeatureDisplay from "../../components/common/FeatureDisplay";
import RequestDemo from "../../components/common/RequestDemo";
import { licenseManagementFeature, licenseManagementFeatures, licenseManagementInfo } from "./solutionConstants";
import ProblemSolved from "../../components/sections/corporateManagement/ProblemSolved";
import licenseManagementAnimation from '../../website animations/License page animation (1) 2.json'

const LicenseManagementPage = () => {
  return (
    <div id="solution" className="flex flex-col items-center justify-center gap-8 sm:gap-16">
      <HeroReuse
        Subtitle="SOLUTIONS"
        Title="License Management"
        Description="Automate license applications and tracking."
        // ButtonText="Request a Demo Today"
        lottie={licenseManagementAnimation}
      />
      <FeatureDisplay infoSectionData={licenseManagementInfo} data={licenseManagementFeature} />
      <ProblemSolved features={licenseManagementFeatures}/>
      <RequestDemo 
       title={'Discover More About License Management'} />
    </div>
  );
};

export default LicenseManagementPage;
